import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-modal-expanded-textfield',
  templateUrl: './modal-expanded-textfield.component.html',
  styleUrls: ['./modal-expanded-textfield.component.css']
})
export class ModalExpandedTextfieldComponent implements OnInit, AfterViewInit {

  shiftIsDown = false;
  textFieldValue: string;

  @Input()
  set TextFieldValue(value: string) {
    this.textFieldValue = value;
  }

  ngClassName: string;
  @Input()
  set NgClassName(ngClassName: string) {
    this.ngClassName = ngClassName
  }

  @Output()
  textFieldValueChange = new EventEmitter();

  @Output()
  closeModal = new EventEmitter();

  @ViewChild('textField') textField;

  constructor() { }

  ngAfterViewInit() {
    $('[data-toggle="tooltip"]').tooltip();
    
    // For some reason autofocus / focus is overwritten shortly
    // after loaded. Added a timeout as a temporary fix.
    setTimeout(() => {
      this.textField.nativeElement.focus();
    }, 650);
  }

  ngOnInit() {
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Shift') {
        this.shiftIsDown = true;
      }
      if (event.key === 'Enter' && this.shiftIsDown) {
        this.textFieldValueChange.emit(this.textFieldValue);
      }
      if (event.key === 'Backspace' && this.shiftIsDown) {
        this.closeModal.emit();
      }
      if (event.key === 'Escape') {
        this.closeModal.emit();
      }
    })

    window.addEventListener('keyup', (event) => {
      if (event.key === 'Shift') {
        this.shiftIsDown = false;
      }
    });
  }

  submit() {
    this.textFieldValueChange.emit(this.textFieldValue);
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/modal-expanded-textfield/modal-expanded-textfield.component.ts